var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowFull = function SvgArrowFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.318 48.477a4 4 0 0 1 0-5.954l45.51-40.834C50.405-.62 54.5 1.206 54.5 4.667v81.667c0 3.46-4.096 5.287-6.671 2.977L2.319 48.477Z"
  })));
};
export default SvgArrowFull;